<!-- Add new Lang for a coupon  -->

<template>
    <div class="modal-mask" v-if="$store.getters.USERPROFILE['campaign-administration']">
        <section class="modal">
            <div class="content">
                <h1>{{$t('createCampaign.newLangTitle')}}</h1>
            </div>
            <hr>
            <div class="content">
                <label>{{$t('createCampaign.lang')}}</label>
                <div class="row">
                    <div class="demiRow">
                        <select v-model="newCouponDescription.lang">
                            <option v-for="item in $t('lang')" :key="item.code" 
                                :value="{title: item.title, code: item.code}">{{item.title}}
                            </option>
                        </select>
                    </div>
                    <p class="tips">{{$t('createCampaign.langTips')}}</p>
                </div>
                <label>{{$t('createCampaign.descriptionCoupons')}} | {{newCouponDescription.lang.title}} </label>
                <div class="row alignCenter">
                    <div class="demiRow">
                        <textarea v-model="newCouponDescription.description"></textarea>
                    </div>
                    <p class="tips">{{$t('createCampaign.descriptionCouponsTips')}}</p>
                </div>
            </div>
            <hr>
            <div class="content">
                <div class="row">
                    <button @click="$emit('add', newCouponDescription)">{{$t('button.add')}}</button>
                    <a  @click="$emit('close')">{{$t('button.cancel')}}</a>
                </div>
            </div>
        </section>
      
    </div>
</template>

<script>
    export default {
        data () {
            return {
                newCouponDescription: {
                    lang: {
                        title: '',
                        code: '',
                    },
                    description: '',
                    id:''
                },
                list: []
            }
        },
        mounted() {
        },
        methods: {
        },
        computed: {
           
        }
    }
</script>